import { createContext, useContext } from 'react';

export enum ViewMode {
  Normal = 'normal',
  Replay = 'replay',
  Detail = 'detail',
  Drawing = 'drawing',
  Kiosk = 'kiosk',
}

export enum DetailView {
  Vessel = 'vessel',
  Aton = 'aton',
}

export interface ViewModeContextProps {
  viewMode: ViewMode;
  setViewMode: (newViewMode: ViewMode, subCategory?: DetailView | null) => void;
  detailView: DetailView | null;
}

export const ViewModeContext = createContext<ViewModeContextProps | undefined>(
  undefined,
);

export const useViewMode = () => {
  const context = useContext(ViewModeContext);
  if (!context) {
    throw new Error('useViewMode must be used within a ViewModeProvider');
  }
  return context;
};
